import { api } from './requestGraphql';

const esc = (v) =>
    String(v ?? '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"');

// Queries
const getOfferCustomOptions = async (offerId) => {
    try {
        const res = await api.post('', {
            query: `
        {
          getOfferCustomOptions(offerId: ${offerId}) {
            id
            offerId
            optionName
            optionValue
            optionParameter
            availableProgramIds
          }
        }
      `,
        });

        const response = res.data.data.getOfferCustomOptions;
        console.log('getOfferCustomOptions response:', response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

// Mutations
const createOfferCustomOption = async (
    offerId,
    optionName,
    optionValue,
    optionParameter,
    availableProgramIds
) => {
    try {
        const res = await api.post('', {
            query: `
        mutation {
          createOfferCustomOption(
            offerId: ${offerId}
            optionName: "${esc(optionName)}"
            optionValue: "${esc(optionValue)}"
            optionParameter: ${optionParameter != null ? `"${esc(optionParameter)}"` : null}
            availableProgramIds: ${availableProgramIds != null ? `"${esc(availableProgramIds)}"` : null}
          ) {
            id
            offerId
            optionName
            optionValue
            optionParameter
            availableProgramIds
          }
        }
      `,
        });

        const response = res.data.data.createOfferCustomOption;
        console.log('createOfferCustomOption response:', response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const updateOfferCustomOption = async (
    id,
    optionName,
    optionValue,
    optionParameter,
    availableProgramIds
) => {
    try {
        const res = await api.post('', {
            query: `
        mutation {
          updateOfferCustomOption(
            id: ${id}
            optionName: "${esc(optionName)}"
            optionValue: "${esc(optionValue)}"
            optionParameter: ${optionParameter != null ? `"${esc(optionParameter)}"` : null}
            availableProgramIds: ${availableProgramIds != null ? `"${esc(availableProgramIds)}"` : null}
          ) {
            id
            offerId
            optionName
            optionValue
            optionParameter
            availableProgramIds
          }
        }
      `,
        });

        const response = res.data.data.updateOfferCustomOption;
        console.log('updateOfferCustomOption response:', response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const deleteOfferCustomOption = async (id) => {
    try {
        const res = await api.post('', {
            query: `
        mutation {
          deleteOfferCustomOption(id: ${id}) {
            id
          }
        }
      `,
        });

        const response = res.data.data.deleteOfferCustomOption;
        console.log('deleteOfferCustomOption response:', response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

export default {
    getOfferCustomOptions,
    createOfferCustomOption,
    updateOfferCustomOption,
    deleteOfferCustomOption,
};
